import { request } from '@/services/fetch';

export async function getTarefasPendentesContagem(clinicaId) {
  const params = new URLSearchParams();
  params.set('clinicaId', String(clinicaId || ''));
  return request(`api/tarefas/contagem-pendentes?${params.toString()}`);
}

export async function listTarefas({ clinicaId, status, q, page = 1, limit = 50 }) {
  const params = new URLSearchParams();
  params.set('clinicaId', clinicaId);
  if (status) params.set('status', status);
  if (q) params.set('q', q);
  params.set('page', String(page));
  params.set('limit', String(limit));
  return request(`api/tarefas?${params.toString()}`);
}

export async function createTarefa(payload) {
  return request('api/tarefas', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateTarefa(id, patch) {
  return request(`api/tarefas/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}

export async function deleteTarefa(id, reason) {
  return request(`api/tarefas/${id}`, {
    method: 'DELETE',
    body: JSON.stringify({ reason }),
  });
}

export async function confirmarRecebimentoTarefa(id) {
  return request(`api/tarefas/${id}/receber`, {
    method: 'PATCH',
    body: JSON.stringify({}),
  });
}
